import { sizeToNumber } from './sizeToNumber';
export const getSizeForBreakpoint = (sizes, offset) => {
    if (Array.isArray(sizes)) {
        do {
            if (sizes[offset]) {
                return sizeToNumber(sizes[offset]);
            }
            offset--;
        } while (offset >= 0);
    }
    else {
        return sizeToNumber(sizes);
    }
    return 1;
};
//# sourceMappingURL=getSizeForBreakpoint.js.map